<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Tax System Check"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'inventoryReport', label: 'Inventory' },
            {
              name: 'taxSystemCheck',
              label: 'Tax System Check',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          :filterByTime="true"
          @submit-filter="performGetReport"
          :isLoading="inventoryTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                    <th align="left">Created</th>
                    <th align="left">Audit Id</th>
                    <th align="left">Item Id</th>
                    <th align="left">Tax Type</th>
                    <th align="right">thc</th>
                    <th align="right">thca</th>
                    <th align="right">thc %</th>
                    <th align="left">Inventory Type</th>
                    <th align="left">Tax Name</th>
                    <th align="right">Tax Rate</th>
                    <th align="right">Tax Amount</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                    <td>{{ record.createdAt }}</td>
                    <td>{{ record.auditId }}</td>
                    <td>{{ record.barcode }}</td>
                    <td>{{ record.orderItemTaxType }}</td>
                    <td align="right">{{ record.thc }}</td>
                    <td align="right">{{ record.thca }}</td>
                    <td align="right">{{ record.thcPercent }}</td>
                    <td>{{ record.inventoryType }}</td>
                    <td>{{ record.taxName }}</td>
                    <td align="right">{{ record.taxRate }}</td>
                    <td align="right">{{ record.taxAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";
  import ReportHelper from "@/lib/report/index.js";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Tax System Check");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        inventoryTransactions: "reports/inventoryTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getSalesTransactions: "reports/getInventoryTransactions",
      }),
      performGetReport(filter) {
        let reportType = "taxSystemCheck";
        this.getSalesTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "taxSystemCheck");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_taxSystemCheck.scss";
  </style>